import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FaqAccordion = ({ items, testId = "faq-accordion" }) => {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid={testId}>
      {items.map((item) => (
        <AccordionItem
          key={item.id}
          value={`item-${item.id}`}
          className="border-b border-slate-200"
        >
          <AccordionTrigger
            data-testid={`faq-q-${item.id}`}
            className="text-left text-base sm:text-lg font-bold text-brand-navy hover:no-underline py-5 hover:text-brand-blue"
          >
            {item.question}
          </AccordionTrigger>
          <AccordionContent className="text-base text-slate-600 leading-relaxed pb-5 pr-6">
            {item.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default FaqAccordion;
